import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {environment} from 'src/environments/environment';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'app-product-enquiry',
  templateUrl: './product-enquiry.component.html',
  styleUrls: ['./product-enquiry.component.css']
})
export class ProductEnquiryComponent implements OnInit {

  enquiryPayLoad = {full_name: '', email: '', mobile_number: '', occasion: 'Yes', occasion_date: '', product_id: ''};
  enquiryResponseAwaited = false;
  enquiryResponseReceived = false;
  enquiryErrorMessage = '';
  enquirySuccessful = false;
  public minDate;
  public maxDate;
  @ViewChild('enquiryForm') enquiryForm: NgForm;


  constructor(
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {

    this.activatedRoute.params.subscribe(params => {
      this.enquiryPayLoad.product_id = params.id;
    });

    this.minDate = new Date();
    this.maxDate = new Date();
    this.minDate.setDate(this.minDate.getDate() + 3);
    this.maxDate.setDate(this.minDate.getDate() + 365);

  }


  submitEnquiry(): void {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };

    this.enquiryResponseAwaited = true;
    if (this.enquiryForm.valid) {

      this.http.post <any>(environment.domain + '/api/product-enquiry', this.enquiryPayLoad, httpOptions).subscribe(
        data => {
          this.enquiryResponseReceived = true;
          if (data.type === 'success') {
            this.enquirySuccessful = true;
          } else {
            this.enquirySuccessful = true;
            this.enquiryErrorMessage = 'Some error occurred';
          }
        },
        error => {
          console.error('There was an error!', error);
          this.enquiryErrorMessage = 'Some error occurred.' + error;
        });
    } else {
      this.enquiryErrorMessage = 'All fields are required';
    }
  }

}
